import { createFileRoute } from "@tanstack/react-router";

import { dataResourceFiltersSearchSchema } from "@/features/datasource/lib/data-resource-search";

export const Route = createFileRoute("/_protected/data")({
  validateSearch: dataResourceFiltersSearchSchema,
});
